import TheButton from "../../../../Components/UI/TheButton/TheButton";
import { logEvent } from "../../../../../Utils/google-analytics";
import { useSFWBuilderHook, useLanguageHook, useRoutingHook } from "../../../../../Hooks/use-context-hooks";
import styles from "./ProductButton.module.css"
export const ProductButton = ({product}) => {
    const {addItemToBuilderList, removeItemFromBuilderList, builderListItems}=useSFWBuilderHook();
     const { setIsRoutingState, setIsFlashMessageState } = useRoutingHook();
    const { language } = useLanguageHook();

    const handleAddToList = () => {
        const productAlreadyInList = builderListItems.find(item => item._id === product._id);
        let message;
        if (productAlreadyInList) {
            removeItemFromBuilderList(product);
            message = language === "EN" ? `Product ${product.title} removed from list` : `Product ${product.title} retiré de la liste!`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'subtracted',
                styleName: 'subtracted'
            }))

            // storeButtonInteraction(`click_removed_${product.title}`);
            logEvent('User Interaction', 'Product_Removed_On_Details_Page', `Product Title: ${product.title}`);
        } else {
            addItemToBuilderList(product);
            message = language === "EN" ? `Product ${product.title} added to list` : `Product ${product.title} ajouté à la liste!`;
            setIsFlashMessageState(prevState => ({
                ...prevState,
                show: true,
                message: message,
                iconType: 'checkmark',
                styleName: 'checkmark'
            }))
        }
        setIsRoutingState(prevState => ({ ...prevState, isFlashMessage: message }))
        logEvent('User Interaction', 'Product_Added_On_Details_Page', `Product Title: ${product.title}`);
    }



    return (
        <div className={styles.buttonBoxWrapper} onClick={handleAddToList}>
            {builderListItems.some(item => item._id === product._id) ?
                <TheButton
                    styleName="blackIconButton"
                    animated="true"
                    // buttonTracking
                    // interactionName={`detailsPage_remove_${product.title}`}
                    buttonIcon="true"
                    iconText={language === "EN" ? "Remove" : "Supprimer"}
                    iconName="subtracted"
                />
                :
                <TheButton
                    animated="true"
                    // buttonTracking
                    // interactionName={`detailsPage_add_${product.title}`}
                    buttonIcon
                    iconText={language === "EN" ? "Add to List" : "Ajouter à la liste"}
                    iconName="add"
                    styleName="redIconButton"
                />
            }
        </div>
    )
}